/* ========================================================
   修正版: 即時関数とjQueryラッパーで囲み、競合を防止しています
   ======================================================== */

// 1. jQueryを使用する部分（カプセル化）
jQuery(function($) {
    // 変数をこの関数内だけのスコープにする（他への干渉を防ぐ）
    var modalWrap = document.querySelector('.modal-wrap');
    var modalOverlay = document.querySelector('.modal-wrap .overlay');

    // タッチデバイス判定
    var isTouchDevice = 'ontouchstart' in window;
    var clickEventType = 'click';
    if (isTouchDevice) {
        clickEventType = 'touchend';
    }

    // モーダルウィンドウを表示する関数
    var openModal = function() {
        if (modalWrap && modalOverlay) {
            modalWrap.classList.add('is-modal_active');
            modalOverlay.classList.add('is-modal_active');
            document.body.style.overflow = 'hidden';
        }
    };

    // モーダルウィンドウを閉じる関数
    var closeModal = function() {
        if (modalWrap && modalOverlay) {
            modalWrap.classList.remove('is-modal_active');
            modalOverlay.classList.remove('is-modal_active');
            document.body.style.overflow = '';
        }
    };

    // ×ボタン押下時イベント
    if ($('.modal-wrap .modal-btn-close').length && $('.modal-wrap .overlay').length) {
        $('.modal-wrap .modal-btn-close').on(clickEventType, function() {
            closeModal();
        });
        // モーダルウィンドウ以外を押下した際のイベント
        $('.modal-wrap .overlay').on(clickEventType, function() {
            closeModal();
        });
    }

    // open-modalボタンのクリックイベント
    $('.open-modal').on(clickEventType, function() {
        openModal();
    });

    // カルーセル (Slick) の設定
    // ※元のコードでは読み込みタイミングが早すぎる可能性があったため、ここに移動しました
    if ($.fn.slick) { // slickが読み込まれているか確認
        $('.apply__slider').slick({
            slidesToShow: 3,
            autoplay: false,
            speed: 800,
            swipeToSlide: true,
            infinite: false,
            dots: true,
            variableWidth: true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    variableWidth: true,
                }
            }]
        });
    }

    // window loadイベント
    $(window).on('load', function() {
        // 安全策: slickInitialize関数が存在する場合のみ実行する
        if (typeof slickInitialize === 'function') {
            slickInitialize();
        }

        if ($('.apply__slider.mynp_01').length) {
            $('.apply__slider.mynp_01').each(function() {
                var _slickTrack = $(this).find('.slick-track'),
                    _slickHeight = _slickTrack.outerHeight();
                _slickTrack.css('height', _slickHeight);
            });
        }
        if ($('.apply__slider.mynp_02').length) {
            $('.apply__slider.mynp_02').each(function() {
                var _slickTrack = $(this).find('.slick-track'),
                    _slickHeight = _slickTrack.outerHeight();
                _slickTrack.css('height', _slickHeight);
            });
        }
    });
});


// 2. Vanilla JSを使用する部分（DOM読み込み後に実行）
document.addEventListener('DOMContentLoaded', function() {
    // 変数宣言をconst/letにし、このブロック内のみ有効にします
    const modalOverlay = document.getElementById('modal-overlay');
    const modal = document.getElementById('modal');
    const closeButton = document.getElementById('modal-close-button');
    const openButtons = document.querySelectorAll('.modal-open-button');
    const modalContentBlocks = document.querySelectorAll('.modal-content-block');

    const openModal = (modalId) => {
        modalContentBlocks.forEach(block => {
            block.classList.remove('is-modal_active');
        });

        const targetModal = document.getElementById(modalId);
        if (targetModal) {
            targetModal.classList.add('is-modal_active');
        }

        if (modalOverlay) {
             modalOverlay.classList.add('is-visible');
        }
    };

    const closeModal = () => {
        if (modalOverlay) {
            modalOverlay.classList.remove('is-visible');
        }
    };

    openButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const modalId = button.getAttribute('data-modal-id');
            openModal(modalId);
        });
    });

    if (closeButton) {
        closeButton.addEventListener('click', closeModal);
    }

    if (modalOverlay) {
        modalOverlay.addEventListener('click', (event) => {
            if (event.target === modalOverlay) {
                closeModal();
            }
        });
    }

    if (modal) {
        modal.addEventListener('click', (event) => {
            event.stopPropagation();
        });
    }
});